import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar
} from 'reactstrap';  
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { hasAccess } from "../../Services/SecurityService";
import { addSecurityGroup, updateSecurityGroup } from "../../Services/SecurityGroupService";
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

class CrudEdit extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      checkAll: false,

      securityProfiles: [],
      checkboxSecurityProfile: [],
      checkboxSecurityProfileSelected: [],

      users: [],
      checkboxUser: [],
      checkboxUserSelected: [],

      data: {
        id: '',
				name: '',
				status: "ATIVO",
				deleted: false,
				createdAt: '',
				updatedAt: ''
      }
    };
  }

  handleSubmit(e){
    const data = { ...this.state.data }

    if(this.validateEntries()){

      if(data.status === undefined || data.status === null || data.status === ''){
        data['status'] = 'ATIVO';
      }

      let request = {
        securityGroup: data,
        securityGroupProfileList: this.getSecurityGroupProfile(),
        securityGroupUserList: this.getGroupUser()
      };

      if(data.id === undefined || data.id === null || data.id === ''){
        addSecurityGroup(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable({}, this.props.t('forms.dataCreateSuccess'));
              this.clear();              
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }
            }
          } else {
            this.show('danger', this.props.t('forms.dataCreateError'));
          }
        });

      }else{
        updateSecurityGroup(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }  
            }
          } else {
            this.show('danger', this.props.t('forms.dataUpdateError'));
          }
        });
      }
    }
  }

  validateEntries(){
    const data = { ...this.state.data }
    let validated = true;

    if(data.name === undefined || data.name === null || data.name === ''){
      this.show('danger', this.props.t('forms.requiredFieldName'));
      validated = false;
    }

    return validated;
  }

  getSecurityGroupProfile() {
    let securityGroupProfiles = [];
    if(this.state.checkboxSecurityProfileSelected.length > 0){
      for(let j = 0; j < this.state.checkboxSecurityProfileSelected.length; j++){
        for(let i = 0; i < this.state.securityProfiles.length; i++){
          if(this.state.checkboxSecurityProfileSelected[j].value === this.state.securityProfiles[i].id){
            securityGroupProfiles.push( {securityProfile: this.state.securityProfiles[i]} );
            break;
          }
        }
      }
    }
    return securityGroupProfiles;
  }

  getGroupUser() {
    let securityGroupUser = [];
    if(this.state.checkboxUserSelected.length > 0){
      for(let j = 0; j < this.state.checkboxUserSelected.length; j++){
        for(let i = 0; i < this.state.users.length; i++){
          if(this.state.checkboxUserSelected[j].value === this.state.users[i].id){
            securityGroupUser.push( {applicationUser: this.state.users[i]} );
            break;
          }
        }
      }
    }
    return securityGroupUser;
  }

  loadData(selected, securityProfiles, securityGroupProfiles, users, securityGroupUsers) {
    let options = [];
    let optionsSelected = [];
    let obj = {};

    console.log(users);
    console.log(securityGroupUsers);

    if(securityProfiles !== undefined && securityProfiles !== null && securityProfiles.length > 0 && this.state.securityProfiles.length === 0){
      if(securityGroupProfiles !== undefined && securityGroupProfiles !== null && securityGroupProfiles.length > 0){
        for(let i = 0; i < securityProfiles.length; i++){
          obj = {value:securityProfiles[i].id, label: securityProfiles[i].name, checked: false};
          for(let j = 0; j < securityGroupProfiles.length; j++){
            if(securityProfiles[i].id === securityGroupProfiles[j].securityProfile.id){
              obj.checked = true;
              optionsSelected.push(obj);
              break;
            }
          }
          options.push(obj);
        }
      }else{
        for(let i = 0; i < securityProfiles.length; i++){
          options.push({value:securityProfiles[i].id, label: securityProfiles[i].name, checked: false});
        }
      }

      this.setState({ 
        checkboxSecurityProfile: options, 
        checkboxSecurityProfileSelected: optionsSelected,
        securityProfiles: securityProfiles 
      });
    }


    if(users !== undefined && users !== null && users.length > 0 && this.state.users.length === 0){
      options = [];
      optionsSelected = [];
      if(securityGroupUsers !== undefined && securityGroupUsers !== null && securityGroupUsers.length > 0){
        for(let i = 0; i < users.length; i++){
          obj = {value:users[i].id, label: users[i].firstName + ' ' + users[i].lastName, checked: false};
          for(let j = 0; j < securityGroupUsers.length; j++){
            if(users[i].id === securityGroupUsers[j].applicationUser.id){
              obj.checked = true;
              optionsSelected.push(obj);
              break;
            }
          }
          options.push(obj);
        }
      }else{
        for(let i = 0; i < users.length; i++){
          options.push({value:users[i].id, label: users[i].firstName + ' ' + users[i].lastName, checked: false});
        }
      }

      this.setState({ 
        checkboxUser: options,
        checkboxUserSelected: optionsSelected,
        users: users 
      });
    }

    if(selected !== undefined && selected !== null){
      if(selected.id === 0){
        this.clear();
      }else {
        console.log(selected);
        this.setState({ 
          data: selected
        }, () => {});
      }
    }
  }

  componentDidMount() {
    const { selected, securityProfiles, securityGroupProfiles, users, securityGroupUsers } = this.props;
    this.loadData(selected, securityProfiles, securityGroupProfiles, users, securityGroupUsers);
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentDidUpdate(props, state) {
    if(props.selected !== this.props.selected || props.securityProfiles !== this.props.securityProfiles || 
        props.securityGroupProfiles !== this.props.securityGroupProfiles || props.users !== this.props.users || 
        props.securityGroupUsers !== this.props.securityGroupUsers){
      this.loadData(this.props.selected, this.props.securityProfiles, this.props.securityGroupProfiles, this.props.users, this.props.securityGroupUsers);
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  updateField(event) {
    const data = { ...this.state.data }
    data[event.target.name] = event.target.value
    this.setState({ data });
  }

  updateCheckboxSecurityGroupProfile(event) {
    let selecteds = [];

    event.checked = !event.checked;
    if(this.state.checkboxSecurityProfileSelected.length > 0){
      for(let i = 0; i < this.state.checkboxSecurityProfileSelected.length; i++){
        if(this.state.checkboxSecurityProfileSelected[i].value !== event.value){
          selecteds.push(this.state.checkboxSecurityProfileSelected[i]);
        }
      }
    }
    if(event.checked){
      selecteds.push(event);
    }
    this.setState({ checkboxSecurityProfileSelected: selecteds });
  }

  updateCheckboxSecurityGroupProfileAll(){
    let selecteds = [];

    if(this.state.checkboxSecurityProfile.length > 0){
      for(let i = 0; i < this.state.checkboxSecurityProfile.length; i++){
        this.state.checkboxSecurityProfile[i].checked = !this.state.checkAll;
        if(!this.state.checkAll){
          selecteds.push(this.state.checkboxSecurityProfile[i]);
        }
      }
    }
    this.setState({ checkboxSecurityProfileSelected: selecteds, checkAll: !this.state.checkAll });
  }

  updateCheckboxSecurityGroupUser(event) {
    let selecteds = [];
    event.checked = !event.checked;
    if(this.state.checkboxUserSelected.length > 0){
      for(let i = 0; i < this.state.checkboxUserSelected.length; i++){
        if(this.state.checkboxUserSelected[i].value !== event.value){
          selecteds.push(this.state.checkboxUserSelected[i]);
        }
      }
    }
    if(event.checked){
      selecteds.push(event);
    }
    this.setState({ checkboxUserSelected: selecteds });
  }


  clear(){
    const data = { ...this.state.data }
    data['id'] = '';
    data['name'] = '';
    data['status'] = '';
    data['deleted'] = '';
    data['createdAt'] = '';
    data['updatedAt'] = '';

    this.setState({ 
      data,
      checkboxSecurityProfileSelected: [],
      checkboxUserSelected: []
    }, () => {});
  }

  cancel(event) {
    this.clear();
    this.props.updateTable({});
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;
    
    let notOK = !hasAccess("MENU_SECURITY_GROUP_SAVE");

    let isEdit = false;
    if(this.state.data.id !== '' && this.state.data.id > 0){
      isEdit = true;
    }

    let checkboxesSecurityProfile = [];
    let checkboxesUser = [];

    let total = this.state.checkboxSecurityProfile.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        checkboxesSecurityProfile.push(
          <div key={"divsecurityProfiles_"+this.state.checkboxSecurityProfile[i].value} className='form__form-inline' style={{width: '270px'}}>
            <input type="checkbox" 
              id={"checkboxsecurityProfiles_"+this.state.checkboxSecurityProfile[i].value} 
              name={"checkboxsecurityProfiles_"+this.state.checkboxSecurityProfile[i].value} 
              style={{float: 'left', width: '30px', height: '18px'}}
              onChange={e => this.updateCheckboxSecurityGroupProfile(this.state.checkboxSecurityProfile[i])}
              checked={this.state.checkboxSecurityProfileSelected.includes(this.state.checkboxSecurityProfile[i])} 
            />
              <label 
                key={"labelsecurityProfiles_"+this.state.checkboxSecurityProfile[i].value}
                htmlFor={"checkboxsecurityProfiles_"+this.state.checkboxSecurityProfile[i].value} 
                style={{margin: 0, height: '25px'}}>
                {this.state.checkboxSecurityProfile[i].label}
              </label>
          </div>
        );
      }
    }

    total = this.state.checkboxUser.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        checkboxesUser.push(
          <div key={"divsecurityUser_"+this.state.checkboxUser[i].value} className='form__form-inline' style={{width: '270px'}}>
            <input type="checkbox" 
              id={"checkboxsecurityUser_"+this.state.checkboxUser[i].value} 
              name={"checkboxsecurityUser_"+this.state.checkboxUser[i].value} 
              style={{float: 'left', width: '30px', height: '18px'}}
              onChange={e => this.updateCheckboxSecurityGroupUser(this.state.checkboxUser[i])}
              checked={this.state.checkboxUserSelected.includes(this.state.checkboxUser[i])} 
            />
              <label 
                key={"labelsecurityUser_"+this.state.checkboxUser[i].value}
                htmlFor={"checkboxsecurityUser_"+this.state.checkboxUser[i].value} 
                style={{margin: 0, height: '25px'}}>
                {this.state.checkboxUser[i].label}
              </label>
          </div>
        );
      }
    }

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="form__form-group">
              <h3 className="page-subhead subhead">{t('forms.createUpdate')}</h3>
            </div>
            <div className="form">

              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.name')} <span style={{color: "#ff0000"}}>*</span>
                </span>
                <div className="form__form-group-field">
                  <input type="hidden" 
                    name="id"
                    value={this.state.data.id} />
                  <input type="text" 
                    name="name"
                    value={this.state.data.name}
                    onChange={e => this.updateField(e)}
                    required
                  />
                </div>
              </div>


              <div className="form__form-group">
                <div style={{float: 'left', marginRight: '5px'}}>
                  <span className="form__form-group-label">
                    {t('forms.securityProfile_form.title')} 
                  </span>
                </div>
                <div style={{float: 'left'}}>
                  <input type="checkbox" 
                    id={"checkboxsecurityProfilesALL"} 
                    name={"checkboxsecurityProfilesAll"} 
                    style={{float: 'left', width: '30px', height: '18px'}}
                    onChange={e => this.updateCheckboxSecurityGroupProfileAll()}
                  /> 
                  <label 
                    key={"labelsecurityProfilesAll"}
                    htmlFor={"checkboxsecurityProfilesAll"}
                    style={{margin: 0, height: '25px'}}>
                    {t('forms.checkAll')} 
                  </label>
                </div>
                <div className="form__form-group-field" 
                  style={{border: '1px solid #CCCCCC', height: '160px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px', fontSize: '10px'}}>
                  
                  {checkboxesSecurityProfile}

                </div>
              </div>


              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.users_form.title')} 
                </span>
                <div className="form__form-group-field" 
                  style={{border: '1px solid #CCCCCC', height: '160px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px', fontSize: '12px'}}>
                  
                  {checkboxesUser}

                </div>
              </div>



              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.status')}
                </span>
                <div className="form__form-group-field">
                  <label className="radio-btn">
                    <input className="radio-btn__radio"
                      name="status"
                      type="radio"
                      value={t('forms.ativo')}
                      onChange={e => this.updateField(e)}
                      checked={this.state.data.status === 'ATIVO' ? true : false}
                    />
                    <span className="radio-btn__radio-custom"></span>
                    <span className="radio-btn__label">{t('forms.ativo')}</span>
                  </label>
                  <label className="radio-btn">
                    <input className="radio-btn__radio"
                      name="status"
                      type="radio"
                      value={t('forms.inativo')}
                      onChange={e => this.updateField(e)}
                      checked={this.state.data.status === 'INATIVO' ? true : false}
                    />
                    <span className="radio-btn__radio-custom"></span>
                    <span className="radio-btn__label">{t('forms.inativo')}</span>
                  </label>
                </div>
              </div>
              
              <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" type="submit" disabled={notOK}
                  onClick={e => this.handleSubmit(e)}>
                  {t('forms.save')}
                </Button>
                <Button type="button" onClick={e => this.cancel(e)}>
                  {isEdit ? t('forms.voltar') : t('forms.cancel')}
                </Button>
              </ButtonToolbar>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'securityGroupEdit', 
})(withTranslation('common')(CrudEdit));
